import { Component, Input, OnDestroy, inject } from '@angular/core';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { OnboardingSelectors } from '../../../store/onboarding/onboarding.selectors';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header-nav',
  imports: [NgOptimizedImage, ProgressbarModule, NgClass],
  templateUrl: './header-nav.component.html',
})
export class HeaderNavComponent implements OnDestroy {
  readonly store = inject(Store);

  @Input() hideProgress = false;
  @Input() showBody = true;
  subs: Subscription[] = [];
  route: string = '/';
  step?: number;
  progress: number = 0;
  showProgress: boolean = false;
  websiteBaseUrl = environment.websiteBaseUrl;

  constructor() {
    this.subs.push(
      this.store.select(OnboardingSelectors.stepAndShowProgress).subscribe({
        next: (state) => {
          this.step = state.step;
          this.showProgress = state.showProgress;
          if (state.showProgress) {
            this.calculateProgress();
          }
        },
      }),
    );
  }

  calculateProgress() {
    if (this.step) {
      this.progress = (this.step / 8) * 100;
    }
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
